import { withRouter } from 'react-router';
import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'shared/utils/wix-connect';

import { DASHBOARD, HELP_LINK_PREFIX } from 'shared/constants/help-articles';

import IconButton from 'shared/components/button/icon/icon';
import { LinkButton } from 'shared/components/button/button';
import { openIFrameModal, closeCatcher } from 'shared/components/modal/modal';

import styles from './header.styl';


@withRouter
@WixConnect(styles)
export default class ModalHeader extends React.Component {

  static propTypes = {
    router: React.PropTypes.object,
    title: React.PropTypes.any,
    className: React.PropTypes.string,
    buttonClassName: React.PropTypes.string,
    titleClassName: React.PropTypes.string,
    onButtonClick: React.PropTypes.func,
    showHelpLink: React.PropTypes.bool,
  };

  static defaultProps = {
    onButtonClick: _.noop,
    showHelpLink: true,
  };

  @autobind
  openHelpModal() {
    const { isActive } = this.props.router;
    let helpLink;

    if (isActive('/video-library')) {
      helpLink = DASHBOARD.LIBRARY;
    } else if (isActive('/channels')) {
      helpLink = DASHBOARD.CHANNELS;
    } else if (isActive('/stats')) {
      helpLink = DASHBOARD.STATS;
    } else if (isActive('/settings')) {
      helpLink = DASHBOARD.SETTINGS;
    }

    openIFrameModal(`${HELP_LINK_PREFIX}${helpLink}`)
      .catch(closeCatcher);
  }

  get helpLink() {
    const { showHelpLink } = this.props;

    if (!showHelpLink) {
      return null;
    }

    return (
      <LinkButton onClick={this.openHelpModal}
                  styleName="button help-button">?</LinkButton>
    );
  }

  get title() {
    const { title, titleClassName } = this.props;

    if (!title) {
      return null;
    }

    return (
      <h1 styleName="title"
          className={titleClassName}>
        {title}
      </h1>
    );
  }

  render() {
    const { onButtonClick, className, buttonClassName } = this.props;

    return (
      <header styleName="header"
              className={className}>
        {this.title}
        {this.helpLink}
        <IconButton styleName="button close-button"
                    className={buttonClassName}
                    onClick={onButtonClick}
                    name="close" />
      </header>
    );
  }
}

function generateHeaderVariant(styleName) {

  @WixConnect(styles)
  class HeaderVariant extends React.Component {
    render() {
      const props = _.omit(this.props, 'styles');

      return (
        <ModalHeader {...props}
                     styleName={styleName} />
      );
    }
  }

  return HeaderVariant;
}

export const DangerModalHeader = generateHeaderVariant('danger');
export const EmptyModalHeader = generateHeaderVariant('empty');
export const SimpleModalHeader = generateHeaderVariant('simple');
export const IFrameModalHeader = generateHeaderVariant('iframe');
export const ModalHeaderWithHelp = generateHeaderVariant('help');



// WEBPACK FOOTER //
// ./src/shared/components/modal/header/header.js